import {ICrudRes} from "../interface/http.config";
import {CrudService} from "../app/dashboard/service/crud.service";
import {Router} from "@angular/router";
import {EFilterType, ICellConfig} from "../interface/table.config";
import {ECrudFilterType} from "../interface/crud.filter-type.enum";

export class CrudListModel {

  constructor(protected crudService: CrudService,
              protected router: Router) {}

  data: ICrudRes;

  editLink = '';
  addLink = '';

  beforeUpdate() {
  }

  protected update() {
    this.beforeUpdate();

    this.crudService.list().then((data: ICrudRes) => {
      this.data = data;
    })
  }

  pageNext() {
    const mxPage = Math.ceil(this.data.total / this.crudService.perPage);

    if (this.crudService.page < mxPage) {
      this.crudService.page++;
      this.update();
    }
  }

  pagePrev() {

    if (this.crudService.page > 1) {
      this.crudService.page--;
      this.update();
    }
  }
  pickPage(page: number) {
    this.crudService.page = page;
    this.update();
  }

  deleteItem(item: any) {
    if (window.confirm('Delete document?')) {
      this.crudService.delete(item).then(() => {
        this.update();
      }).catch(console.error);
    }
  }

  editItem(item: any) {
    this.router.navigate([this.editLink + item.id]).catch(console.error);
  }

  nwItem() {
    this.router.navigate([this.addLink]).catch(console.error);
  }

  csv() {
    this.crudService.list(true).catch(console.error);
  }

  changeSort(data: any) {
    const {field} = data;

    if (this.crudService.orderBy !== field) {
      this.crudService.orderBy = field;
      this.crudService.orderDirection = 'desc';
    } else {
      this.crudService.orderDirection = this.crudService.orderDirection === 'desc' ? 'asc' : 'desc';
    }

    this.update();
  }

  changeFilter(data: {field: string, value: any, config: ICellConfig}) {
    this.crudService.filters = {
      ...this.crudService.filters,
      [data.field]: data.value,
    };

    this.crudService.filterTypes = {
      ...this.crudService.filterTypes,
      [data.field]: data.config.crudFilterType || ECrudFilterType.SEARCH,
    }


    let label = data.value;
    if (data.value) {
      if (data.config.filterType === EFilterType.SELECT && data.config.options) {
        label = data.config.options().find(item => item.value === data.value)?.label;
      }
    }


    console.log(label);


    this.crudService.filterLabels = {
      ...this.crudService.filterLabels,
      [data.field]: label,
    }

    this.update();
  }


  onAction(actionName: string, data: any) {
    if (actionName === 'page-next') this.pageNext();
    if (actionName === 'page-prev') this.pagePrev();
    if (actionName === 'pick-page') this.pickPage(data);
    if (actionName === 'change-search') this.changeSort(data);
    if (actionName === 'change-field') this.changeFilter(data);
    if (actionName === 'new') this.nwItem();
    if (actionName === 'edit') this.editItem(data);
    if (actionName === 'delete') this.deleteItem(data);
    if (actionName === 'csv') this.csv();
  }
}
